<template>
  <div class="geo__item">
    <ul class="geo__header">
      <li class="geo__title">
        {{title}}
      </li>
      <li class="geo__tools">
        <el-button type="text" class="geo__tools-button" :disabled="saveChart" @click="onSave()">
          <i class="material-icons color_grey">save</i>
        </el-button>
        <!--<el-button type="text" class="geo__tools-button" v-if="!isEdit" @click="editChart(name)">
          <i class="material-icons color_grey">edit</i>
        </el-button>-->
      </li>
    </ul>

    <el-card shadow="hover" class="geo__card" v-loading="isPending">
      <geo-header
        :chart-name="name"
        :city-list="cityArr"
        :active-city="activeCity"
        @setCity="setCity"
      />
      <geo-body
        :chartData="chartData"
        :chart-name="name"
        :save-chart="saveChart"
        :active-city="activeCity"
        :title="title"
        @onSavedChart="handleSaved"
        @onSaveChart="handleSave"
      />
    </el-card>
  </div>
</template>

<script>
  // components
  import GeoHeader from './header/GeoHeader';
  import GeoBody from './body/GeoBody';

  // api
  import { getCityApi, getCityReportApi } from '@/api/stats';

  export default {
    name: "Geo",
    data() {
      return {
        name: "Geo",
        title: this.$t('feed.audit.geo.title'),
        saveChart: false,
        pending: false,
        cityArr: [],
        activeCity: 'Санкт-Петербург',
        chartData: {},
      };
    },
    methods: {
      editChart() {
        this.$router.push({
          name: 'feedAuditEdit',
          params: {
            chart: "Geo"
          }
        });
      },
      onSave() {
        this.saveChart = true;
      },
      handleSaved() {
        this.pending = false;
        this.saveChart = false;
      },
      handleSave() {
        this.pending = false;
      },
      setCity(value) {
        this.activeCity = value;
        this.pending = true;
        this.getReport();
      },
      getReport() {
        const params = {
          thread_id: this.$route.params.threadId,
          city: this.activeCity,
        };

        getCityReportApi(params).then((resp) => {
          this.chartData = {
            users_city: resp.data.users_city,
            users_undefined: resp.data.users_undefined,
            other_cities_users: resp.data.other_cities_users
          };

          this.pending = false;
        });
      }
    },
    computed: {
      isEdit() {
        return this.$route.meta.singlePage;
      },
      isPending() {
        return this.pending;
      },
    },
    mounted() {
      this.pending = true;

      const params = {
        thread_id: this.$route.params.threadId
      };

      getCityApi(params).then((resp) => {
        this.cityArr = resp.data;
        //this.activeCity = this.cityArr[0];
        this.getReport();
      });

    },
    components: {
      GeoHeader,
      GeoBody,
    }
  }
</script>

<style>

  .geo__item {
    flex-basis: 50%;
    margin-right: 20px;
  }

  .geo__item:last-child {
    margin-right: 0;
  }

  .geo__card {
    margin-bottom: 20px;
  }


  .geo__header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .geo__title {
    margin-bottom: 20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #5E6D82;
  }

  .geo__tools .material-icons {
    font-size: 16px;
  }

  .geo__tools {
    margin-top: 4px;
    margin-right: 15px;
  }

  .geo__tools-button {
    padding: 0;
    color: #5e6d82;
  }

  .geo__tools-button:hover {
    color: #B3BCCC;
    font-size: 12px;
  }
</style>

